const base = "/admin/monitoring/event-trace";

export function dashboardTraceUrl(from, to, filters = {}) {
  return `${base}?${new URLSearchParams({ ...filters, event_time: "all", received_at_from: from, received_at_to: to })}`;
}

export const dashboardCardFilters = {
  "Global Events": {},
  Processing: { status: "Processing", stage: "Dispatcher" },
  Attendance: { stage: "Attendance" },
};

export const dashboardRowFilters = {
  "Global Events": {
    Processing: { status: "Received,Processing", stage: "Global Event,Tenant Targeting" },
    Failed: { status: "Failed", stage: "Tenant Targeting" },
  },
  Processing: {
    Pending: { status: "Processing", stage: "Dispatcher" },
    Retry: { status: "Retry", stage: "Dispatcher" },
    Quarantined: { status: "Quarantined", stage: "Dispatcher" },
  },
  Attendance: {
    Completed: { status: "Completed", stage: "Attendance" },
    Processing: { status: "Processing,Retry", stage: "Attendance" },
    Quarantined: { status: "Quarantined", stage: "Attendance" },
  },
};

export const recentIssueFilters = { status: "Retry,Quarantined", stage: "Dispatcher" };
